<div class="row">
  <div class="col-lg">
    <div class="fw-bold">{{ 'common.details' | translate }}</div>
    <div>{{ formatPatientName(patient()) }}</div>
    <div>
      {{ patient().postal_code }}
      {{ patient().city }}
    </div>
  </div>

  <div class="col-lg">
    <div class="fw-bold">{{ 'common.email' | translate }}</div>
    <div>{{ patient().email }}</div>
  </div>

  <div class="col-lg">
    <div class="fw-bold">{{ 'common.phone' | translate }}</div>
    <div>{{ patient().phone }}</div>
  </div>
</div>
